/**
 * @ngdoc service
 * @name cookiesconsent
 *
 * @description Cookie consent servcie.
 */
module.factory('cookiesconsent', ['$filter', function ($filter) {
    'use strict';

    var consent = function (message) {
        if (!cookieconsent || !window['cookieconsent']) {
            console.error('Cookie Consent is not available');
            return;
        }
        window['cookieconsent'].initialise({
            onStatusChange: function () {
                console.log('Cookie Consent done');
            },
            elements: {
                close: '<a aria-label="dismiss cookie message" tabindex="0" class="cc-btn cc-dismiss"><span class="is-sr-only">{{close}}</span></a>',
            },
            compliance: {
                'info': '<div class="cc-compliance">{{close}}</div>',
            },
            showLink: false,
            revokable: false,
            content: {
                message: message,
                close: $filter('translate')('common.ok')
            }
        });
    }

    return {
        ask: consent
    };
}]);
